import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { RouteObject } from "react-router-dom";

import { Failed as FailedComponent } from "@/common/components/info/info";
import { Spinner } from "@/common/components/spinner/spinner";

import { wrapWithCompanyGuards } from "../routes.utils";
import { Params } from "../shared/currency.params";
import * as Storages from "./storages";
import * as NewCrop from "./storages.crop.new";
import * as StoragesManagement from "./storages.management";
import * as Offer from "./storages.offer";
import * as OfferEdit from "./storages.offer.edit";
import * as Storage from "./storages.storage";

const routes: RouteObject[] = wrapWithCompanyGuards([
  {
    children: [
      {
        children: [
          {
            element: <Storage.ExistingStorage />,
            path: ":id",
          },
          {
            element: <Storage.NewStorage />,
            path: Storage.path,
          },
          {
            element: <NewCrop.NewCrop />,
            path: `:id/${NewCrop.path}`,
          },
          {
            element: <Offer.Offer />,
            path: Offer.path,
          },
          {
            element: <OfferEdit.OfferEdit />,
            path: OfferEdit.path,
          },
        ],
        element: <StoragesManagement.Management />,
        path: StoragesManagement.path,
      },
      {
        element: <Offer.Offer />,
        path: Offer.path,
      },
      {
        element: <OfferEdit.OfferEdit />,
        path: OfferEdit.path,
      },
    ],
    element: (
      <ErrorBoundary
        fallbackRender={({ error }) => <FailedComponent error={error} />}
      >
        <React.Suspense fallback={<Spinner />}>
          <Params>
            <Storages.Storages />
          </Params>
        </React.Suspense>
      </ErrorBoundary>
    ),
    path: Storages.path,
  },
]);

export { routes };
